module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/electric/fan-78c97186be4a5db7f24480cd9b0c8b96.svg";